import React from 'react';

import './BeforeElectionTeaser.styl';

export default () => {
  return (
    <div className="before-election-teaser">
      <div className="before-election-teaser__title">Wahlergebnis der Europawahl 2019</div>
      <div>Alle Ergebnisse hier am 26.05.2019 ab 23:00</div>
    </div>
  );
};
